// @flow

// Check if the browser is online
export function isOnline (): boolean {
  if (typeof window !== 'undefined' && 'navigator' in window && 'onLine' in window.navigator) {
    return window.navigator.onLine
  }
  // Assume online if we can't detect
  return true
}

// Add event listeners for online/offline events
export function addNetworkListeners (
  onOnline: () => void,
  onOffline: () => void
): () => void {
  if (typeof window === 'undefined') {
    return (): void => {}
  }

  window.addEventListener('online', onOnline)
  window.addEventListener('offline', onOffline)

  // Return cleanup function
  return (): void => {
    window.removeEventListener('online', onOnline)
    window.removeEventListener('offline', onOffline)
  }
}

// Check if error is due to network issues
export function isNetworkError (error: any): boolean {
  if (!error) return false

  // Check for common network error codes
  const networkErrorCodes = [
    'ERR_NETWORK',
    'ERR_INTERNET_DISCONNECTED',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ENOTFOUND',
    'ECONNREFUSED',
    'ECONNRESET',
    'ERR_NAME_NOT_RESOLVED'
  ]

  if (error.code && networkErrorCodes.includes(error.code)) {
    return true
  }

  // Check for network error messages
  const networkErrorMessages = [
    'network error',
    'networkerror',
    'failed to fetch',
    'load failed',
    'could not connect',
    'connection refused',
    'connection reset'
  ]

  const errorMessage = (error.message || '').toLowerCase()
  return networkErrorMessages.some((msg: string): boolean => errorMessage.includes(msg))
}

// Get user-friendly error message
export function getNetworkErrorMessage (error: any): string {
  if (!isOnline()) {
    return 'You appear to be offline. Please check your internet connection and try again.'
  }

  if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
    return 'The request timed out. Please check your connection and try again.'
  }

  if (isNetworkError(error)) {
    return 'Unable to connect to Dipsea. Please check your internet connection and try again.'
  }

  // Default message
  return 'Something went wrong. Please try again.'
}
